import React, { FC } from "react";

import { Grid, Skeleton } from "@mui/material";
import { styled, Theme } from "@mui/material/styles";
import { SxProps } from "@mui/system";

import { IgAzurePrimitives, IgCustomTheme } from "./theme";

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .ag-theme-alpine .ag-cell`]: {
    lineHeight: "unset",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  [`.ag-body-vertical-scroll`]: {
    width: "0 !important",
    minWidth: "0 !important",
  },
  ".ag-body-vertical-scroll-viewport": {
    right: "6px",
  },
  "& ::-webkit-scrollbar": {
    width: "5px",
  },
  "& .ag-aria-description-container": {
    display: "none",
  },
  "& .ag-body-viewport ": {
    overscrollBehavior: "contain",
  },
  [`ag-body-vertical-scroll-viewport`]: {
    right: "6px",
  },
  [`& .ag-root-wrapper`]: {
    border: `solid 1px ${(theme as IgCustomTheme).igBorders.core.default} !important`,
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",
    fontFamily: `${theme.typography.fontFamily}`,
    fontSize: "14px",
    fontWeight: 400,
  },
  [`.ag-full-width-row .ag-cell-wrapper.ag-row-group`]: {
    paddingRight: "10px !important",
  },
  [`& .ag-header-row`]: {
    backgroundColor: IgAzurePrimitives[100],
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
  },
  [`& .ag-header-cell-text`]: {
    color: theme.palette.text.primary,
    fontWeight: "600",
  },
  [`& .ag-theme-alpine .ag-cell-inline-editing`]: {
    height: `50px`,
  },
  [`& .ag-header-row-column-group`]: {
    backgroundColor: IgAzurePrimitives[100],
  },
  [`& .ag-header-row:not(:first-of-type) .ag-header-cell`]: {
    borderTop: "solid 0px !important",
  },
  [`& .ag-header-group-text`]: {
    fontWeight: 500,
  },
  [`& .ag-header-group-cell-label`]: {
    justifyContent: "center",
  },
  [`& .ag-group-value`]: {
    width: "100%",
  },
  [`& .ag-header-icon`]: {
    color: (theme as IgCustomTheme).igIconColors.light,
  },
  [`& .ag-sort-indicator-icon`]: {
    color: (theme as IgCustomTheme).igIconColors.light,
  },
  [`& .ag-icon-filter`]: {
    color: (theme as IgCustomTheme).igIconColors.light,
  },
  [`& .ag-header-cell-resize:after`]: {
    // backgroundColor: (theme as IgCustomTheme).igIconColors.light,
  },
  [`& .ag-popup-child:not(.ag-tooltip-custom)`]: {
    // backgroundColor: (theme as IgCustomTheme).igIconColors.light,
    borderRadius: "10px",
    fontFamily: `${theme.typography.fontFamily}`,
    fontSize: "14px",
    fontWeight: 400,
  },
  [`& .ag-header-cell-label`]: {
    justifyContent: "center",
    fontWeight: 400,
    marginRight: "-16px",
    fontSize: "14px",
  },
  // for the exp table alignment
  [`& .header-custom`]: {
    "& .ag-header-cell-label": {
      justifyContent: "left !important",
    },
  },
  [`& .header-custom2`]: {
    "& .ag-header-cell-label": {
      marginRight: "0px !important",
    },
  },
  [`& .performance-header`]: {
    "& .ag-header-cell-label": {
      fontSize: "14px",
    },
  },
  borderRadius: "8px",
  border: (theme as IgCustomTheme).igBorders.core.default,
}));

interface IgTableWrapperProps {
  children: any;
  isLoading?: boolean;
  minHeight?: string | null;
  height?: string | null;
  maxHeight?: string;
  sx?: SxProps<Theme>;
}

/**
 * @see Grid
 * @see Skeleton
 */
export const IgTableWrapper: FC<IgTableWrapperProps> = ({
  children,
  height,
  isLoading,
  minHeight,
  maxHeight,
  sx,
}) => {
  return (
    <StyledGrid direction={"column"} container item sx={sx}>
      {isLoading ? (
        <Skeleton
          variant={"rectangular"}
          height={height === null ? undefined : height || "500px"}
          sx={maxHeight ? { maxHeight } : undefined}
        />
      ) : (
        <div
          className="ag-theme-alpine"
          style={{
            minHeight: minHeight === null ? undefined : minHeight || "500px",
            height: height === null ? undefined : height || "500px",
            maxHeight,
          }}
        >
          {children}
        </div>
      )}
    </StyledGrid>
  );
};
